// extracted by extract-css-chunks-webpack-plugin
module.exports = {"titleWrapper":"_2DWUq","title":"_1K0ub","count":"a_zYV","header":"_2NT48","content":"_9ka80","hideMobileTitle":"hAoNR"};